/* Vorelisse — global davranışlar. Bileşene özel JS kendi dosyasında. */

(function () {
  'use strict';

  /* --- Görünüme girince ortaya çıkma ------------------------------------- */

  function initReveal() {
    var targets = document.querySelectorAll('.reveal');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
    );

    targets.forEach(function (el) {
      if (el.classList.contains('is-armed')) return;

      // Ekranda zaten görünen öğeye dokunma — gizleyip sonra göstermek
      // hem gereksiz hem riskli.
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) return;

      // Aynı kabın içindeki kardeşler sırayla girer (60ms, en fazla 5 adım).
      var siblings = el.parentElement
        ? Array.prototype.filter.call(el.parentElement.children, function (n) {
            return n.classList && n.classList.contains('reveal');
          })
        : [el];
      var index = siblings.indexOf(el);
      if (index > 0) {
        el.style.transitionDelay = Math.min(index, 5) * 60 + 'ms';
      }

      el.classList.add('is-armed');
      observer.observe(el);
    });
  }

  /* --- Sepet sayısını sunucuya gitmeden tazele --------------------------- */

  function refreshCartCount() {
    return fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      });
  }

  /* --- Para biçimlendirme ------------------------------------------------- */
  /* Mağazanın money_format'ını kullanır, böylece JS ile Liquid aynı biçimi
     üretir. Format dizesi theme.liquid'de shop.money_format'tan geliyor. */

  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return '0';

    var number = (cents / 100.0).toFixed(precision);
    var parts = number.split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var fraction = parts[1] ? decimal + parts[1] : '';

    return whole + fraction;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!match) return format;

    var value;

    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2, ',', '.');
    }

    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* --- Sepet çekmecesi -----------------------------------------------------

     Sepet HTML'i bu dosyada ÜRETİLMEZ. Her değişiklikten sonra Shopify'ın
     Section Rendering API'siyle (`?sections=cart-drawer`) sunucudan taze HTML
     alınır. Böylece fiyat, indirim ve para birimi mantığının tek kaynağı
     Liquid olur; burada ikinci bir şablon tutulsaydı ikisi zamanla ayrışırdı.
     -------------------------------------------------------------------------- */

  var SECTION_ID = 'cart-drawer';
  var lastFocus = null;

  function drawerRoot() {
    return document.getElementById('shopify-section-' + SECTION_ID);
  }

  function drawerEl() {
    var root = drawerRoot();
    return root ? root.querySelector('[data-cart-drawer]') : null;
  }

  function openDrawer() {
    var el = drawerEl();
    if (!el) return;

    lastFocus = document.activeElement;
    el.hidden = false;
    document.body.classList.add('is-locked');

    // hidden kalktıktan sonra bir kare beklenir; yoksa tarayıcı başlangıç ve
    // bitiş durumunu aynı karede görür ve geçiş hiç oynamaz.
    requestAnimationFrame(function () {
      el.classList.add('is-open');
    });

    var focusTarget = el.querySelector('[data-cart-close]');
    if (focusTarget) focusTarget.focus();
  }

  function closeDrawer() {
    var el = drawerEl();
    if (!el) return;

    el.classList.remove('is-open');
    document.body.classList.remove('is-locked');

    var panel = el.querySelector('[data-cart-panel]');
    var done = function () {
      el.hidden = true;
    };

    if (panel) {
      panel.addEventListener('transitionend', done, { once: true });
      // Geçiş hiç tetiklenmezse (reduced-motion) çekmece açık kalmasın.
      setTimeout(done, 600);
    } else {
      done();
    }

    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function isOpen() {
    var el = drawerEl();
    return el && !el.hidden;
  }

  /* Sunucudan taze çekmece HTML'i al ve yerine koy. */
  function refreshDrawer() {
    var root = drawerRoot();
    if (!root) return Promise.resolve();

    var url =
      window.location.pathname + '?sections=' + SECTION_ID + '&_=' + Date.now();

    /* DİKKAT: burada 'Accept: application/json' GÖNDERİLMEZ.

       Ürün sayfasında o başlıkla istek atınca Shopify, sections parametresini
       yok sayıp ÜRÜN JSON'unu döndürüyor ({"product": {...}}) — çekmece de
       boş kalıyordu. Section Rendering API zaten ?sections= ile JSON döner,
       başlığa gerek yok. */
    return fetch(url)
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var html = data[SECTION_ID];
        if (!html) return;

        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        // Gelen yanıt bölümün kendi sarmalayıcısını da içerir; içeriğini alırız.
        var fresh = wrapper.querySelector('#shopify-section-' + SECTION_ID);
        var wasOpen = isOpen();

        root.innerHTML = fresh ? fresh.innerHTML : wrapper.innerHTML;

        if (wasOpen) {
          var el = drawerEl();
          if (el) {
            el.hidden = false;
            el.classList.add('is-open');
          }
        }
      })
      .catch(function () {
        /* Sessizce geç: sepet sunucuda değişti, yalnız görsel tazeleme kaçtı. */
      });
  }

  function cartRequest(path, body) {
    return fetch(window.Shopify.routes.root + path, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw json;
        return json;
      });
    });
  }

  function afterCartChange() {
    return Promise.all([refreshCartCount(), refreshDrawer()]);
  }

  /* Ürün formunu sayfayı yenilemeden gönder. */
  function initAjaxAddToCart() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches('form[action*="/cart/add"]')) return;

      /* Hazır ödeme (Shop Pay / Apple Pay / "Hemen satın alın") düğmeleri de
         AYNI formun içinde. Onları Shopify'ın kendi betiği yönetir ve doğrudan
         ödemeye götürür — araya girersek hızlı ödeme akışı kırılır. */
      if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;

      event.preventDefault();

      var button = form.querySelector('[data-add-button]');
      var label = button ? button.querySelector('[data-add-text]') : null;
      var original = label ? label.textContent : '';
      var strings = (window.theme && window.theme.strings) || {};

      if (button) button.classList.add('is-loading');
      if (label && strings.adding) label.textContent = strings.adding;

      /* Çok satırlı ekleme.

         Bir üründen birden fazla alınırken her adet için AYRI varyant
         seçilebiliyor (ürün sayfasındaki "Her ürün için seçim yapın"
         paneli). Böyle bir seçim varsa ürün bölümü, forma gizli bir
         `{items:[…]}` gövdesi yazar ve onu JSON olarak göndeririz —
         FormData tek bir `id` + `quantity` taşıyabildiği için bunu
         ifade edemez.

         Alan boşsa (tek ürün, ya da panelin hiç olmadığı bir sayfa)
         eskisi gibi FormData gider. */
      var payload = form.querySelector('[data-cart-payload]');
      var body = payload && payload.value ? payload.value : null;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: body
          ? { Accept: 'application/json', 'Content-Type': 'application/json' }
          : { Accept: 'application/json' },
        body: body || new FormData(form)
      })
        .then(function (res) {
          return res.json().then(function (json) {
            if (!res.ok) throw json;
            return json;
          });
        })
        .then(function () {
          return afterCartChange();
        })
        .then(function () {
          openDrawer();
        })
        .catch(function (err) {
          // Sunucu reddettiyse (stok yok, seçenek eksik) kullanıcıya söyle.
          var message = (err && err.description) || strings.error;
          if (message) window.alert(message);
        })
        .then(function () {
          if (button) button.classList.remove('is-loading');
          if (label) label.textContent = original;
        });
    });
  }

  function initDrawerEvents() {
    document.addEventListener('click', function (event) {
      var close = event.target.closest('[data-cart-close]');
      if (close) {
        event.preventDefault();
        closeDrawer();
        return;
      }

      // Başlıktaki sepet bağlantısı: JS varsa çekmeceyi açar.
      var cartLink = event.target.closest('.header__action--cart');
      if (cartLink && drawerEl()) {
        event.preventDefault();
        openDrawer();
        return;
      }

      var change = event.target.closest('[data-line-change]');
      if (change) {
        event.preventDefault();
        var line = change.closest('[data-line]');
        if (!line) return;

        change.disabled = true;
        cartRequest('cart/change.js', {
          line: parseInt(line.getAttribute('data-line'), 10),
          quantity: parseInt(change.getAttribute('data-line-change'), 10)
        })
          .then(afterCartChange)
          .catch(function () {
            change.disabled = false;
          });
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || !isOpen()) return;
      closeDrawer();
    });

    /* Odak tuzağı: çekmece açıkken sekme tuşu panelin dışına çıkmaz. */
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !isOpen()) return;

      var panel = drawerEl().querySelector('[data-cart-panel]');
      if (!panel) return;

      var focusable = panel.querySelectorAll(
        'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  /* --- Görsel büyütme katmanı ----------------------------------------------

     Sahnedeki görsele (ya da büyüteç düğmesine) tıklanınca tam ekran açılır.
     Yüksek çözünürlüklü kaynak yalnız O AN indirilir: slaytın data-zoom-src
     değeri kullanılır, sayfa yükünde ikinci bir görsel seti inmez.
     -------------------------------------------------------------------------- */

  function initLightbox() {
    var lightbox = document.querySelector('[data-lightbox]');
    var gallery = document.querySelector('[data-gallery]');
    if (!lightbox || !gallery) return;

    /* Katmanı doğrudan <body>'ye taşı.

       Bölümler `position: relative; z-index: 1` taşıyor, yani her biri kendi
       yığın bağlamını (stacking context) kuruyor. Katman ürün bölümünün
       İÇİNDE kaldığında z-index: 90 yalnız o bölümün içinde geçerli oluyordu;
       başlık, geri sayım çubuğu ve sonraki bölümler karartmanın ÜSTÜNE
       çiziliyordu. Body'nin doğrudan çocuğu olunca sorun kalmıyor. */
    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    var image = lightbox.querySelector('[data-lightbox-image]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var openerFocus = null;
    var index = 0;

    if (slides.length < 2) lightbox.classList.add('lightbox--single');

    function activeIndex() {
      var found = slides.findIndex(function (slide) {
        return slide.classList.contains('is-active');
      });
      return found < 0 ? 0 : found;
    }

    function show(i) {
      // Dizinin iki ucunda da dolan: son görselden sonra başa döner.
      index = (i + slides.length) % slides.length;

      var slide = slides[index];
      var src = slide.getAttribute('data-zoom-src');
      // Video/3B ortamda zoom kaynağı yok — o slaytı atla.
      if (!src) return;

      var img = slide.querySelector('img');
      image.src = src;
      image.alt = img ? img.alt : '';
    }

    function open() {
      var slide = slides[activeIndex()];
      if (!slide || !slide.getAttribute('data-zoom-src')) return;

      openerFocus = document.activeElement;
      show(activeIndex());
      lightbox.hidden = false;
      document.body.classList.add('is-locked');
      requestAnimationFrame(function () {
        lightbox.classList.add('is-open');
      });

      var closeBtn = lightbox.querySelector('[data-lightbox-close]');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      lightbox.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      setTimeout(function () {
        lightbox.hidden = true;
        // Kaynağı bırak: geri dönüldüğünde bellekte tutulmasın.
        image.removeAttribute('src');
      }, 400);

      if (openerFocus && openerFocus.focus) openerFocus.focus();
    }

    gallery.addEventListener('click', function (event) {
      if (event.target.closest('[data-gallery-thumb]')) return;
      if (!event.target.closest('.gallery__stage')) return;
      event.preventDefault();
      open();
    });

    lightbox.addEventListener('click', function (event) {
      if (event.target.closest('[data-lightbox-close]')) return close();
      if (event.target.closest('[data-lightbox-prev]')) return show(index - 1);
      if (event.target.closest('[data-lightbox-next]')) return show(index + 1);
      // Görselin dışına tıklamak da kapatır.
      if (event.target === lightbox) close();
    });

    document.addEventListener('keydown', function (event) {
      if (lightbox.hidden) return;
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
  }

  /* --- İçerik koruma (sağ tık / kopyalama) ---------------------------------

     Tema ayarından açılır. <html> üzerinde data-protect-content varsa çalışır.

     DÜRÜST SINIR: bu bir güvenlik önlemi DEĞİL. Sayfa kaynağı, geliştirici
     araçları, ekran görüntüsü ve "sayfayı kaydet" hâlâ çalışır; görselin
     adresini bilen herkes indirebilir. Yaptığı tek şey, sıradan ziyaretçinin
     sağ tıklayıp "resmi kaydet" ya da metni seçip kopyalamasını zorlaştırmak.

     FORM ALANLARI HARİÇ TUTULUR. Aksi hâlde müşteri kargo takip numarasını
     yapıştıramaz, adresini düzeltemez, hediye notunu kopyalayamaz — yani
     korumanın bedelini satın alma niyeti olan kişi öder. */

  function initContentProtection() {
    if (!document.documentElement.hasAttribute('data-protect-content')) return;

    function inField(target) {
      return target && target.closest
        ? target.closest('input, textarea, select, [contenteditable="true"]')
        : null;
    }

    document.addEventListener('contextmenu', function (event) {
      if (inField(event.target)) return;
      event.preventDefault();
    });

    ['copy', 'cut'].forEach(function (tur) {
      document.addEventListener(tur, function (event) {
        if (inField(event.target)) return;
        event.preventDefault();
      });
    });

    /* Görseli masaüstüne sürükleyip bırakma. */
    document.addEventListener('dragstart', function (event) {
      if (event.target && event.target.tagName === 'IMG') event.preventDefault();
    });
  }

  /* --- Bölüm yeniden yüklendiğinde tema editörü için ---------------------- */

  /* Tema editöründe bir bölüm yeniden yüklendiğinde eski DOM atılır; o DOM'a
     bağlı dinleyiciler de gider. Belge düzeyinde çalışanlar (sepet çekmecesi)
     etkilenmez, ama büyütme katmanı kendi elemanına bağlı — yeniden kurulur. */
  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initLightbox();
  });

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContentProtection();
    initAjaxAddToCart();
    initDrawerEvents();
    initLightbox();
  });

  window.theme = window.theme || {};
  window.theme.refreshCartCount = refreshCartCount;
  window.theme.formatMoney = formatMoney;
  window.theme.openCartDrawer = openDrawer;
  window.theme.closeCartDrawer = closeDrawer;
})();
